<template>
  <div class="sendMessageInfo">
    <k-dialog
      class="uploadModel"
      ref="sendEmailDialog"
      :options="{
        title:title,
        center: true,
        width: '30%',
        top: '0',
        destroyOnClose: true,
        isCanClickClose: false,
        showClose: true,
        onCloseBefore: closeEmail,
        buttons: [
          // { text: '取消', handler: closeMsg },
          // { text: '确定', handler: closeMsg }
        ]
      }"
    >
      <div class="openModal">
        <div class="modal-body">
          <div class="update_main">
            <div class="item">
              <el-form :model="{}">
                <k-input ref="EMAIL" id="EMAIL" :label="label" :value.sync="EMAIL"
                  validtype="email|on-change" buttontxt="发送邮件" :correct.sync="correct"
                  :clickButton="sendEmail"  :required="true" />
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </k-dialog>
  </div>
</template>

<script>
import kDialog from "../../common/dialog.vue";
import kInput from "@/components/baseUI/kInput";
import smsService from "@/service/sms-service";

export default {
  props: {
    title: {
      type: String,
      default:"邮件发送",
    },
    label: {
      type: String,
      default:"电子邮箱",
    },
  },
  components: {
    kDialog,
    kInput
  },
  data () {
    return {
      EMAIL: "", 
      correct: false
    };
  },
  computed: {
    // apptSn () {
    //   return this.$store.state.apptSn;
    // }
  },
  mounted () {
    this.$refs.sendEmailDialog.open();
  },
  methods: {
    //发送短信验证码
    async sendEmail () {
      this.$refs.EMAIL.$children[0].$refs.EMAIL.validate("change");
      let that = this;
      setTimeout(() => {
        if (!that.EMAIL || !that.correct) {
          alert("请填写正确的邮箱");
          return false;
        }
        this.$store.commit(this.$types.UPDATE_LOADING, "正在发送");
        this.$emit("sendEmailMsg", this.EMAIL);
      }, 200);
    },
    closeEmail () {
      // this.modelClose = false;
      this.$emit("closeEmail", this.modelClose);
    },
  }
};
</script>

<style lang="less" scoped>
.sendMessageInfo{
  .commom-dialog{
    .el-form{
      padding: 0.2rem;
    }
    .el-form-item{
      // width: 80%;
      margin-left: 0;
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/components/imageNode/child/sendEmail.vue